import { createAsyncThunk } from '@reduxjs/toolkit';
import { addLoading, removeLoading } from '../appAction';
import { Enums, Value } from '@utils/constants';
import { axios } from '@utils/lib';
import { IListRes } from '@interfaces/apis/response-data';
import paths from '@utils/constants/paths';

export const getSMSLogAsync = createAsyncThunk(
  'api/getSMSLogAsync',
  async (query: IBaseQuery, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    const searchQuery: Record<string, string> = {
      page: String(query.page ?? Value.TABLE_PAGE_INIT),
      pageSize: String(query.pageSize ?? Value.TABLE_PAGE_SIZE),
      order: 'DESC',
    };

    searchQuery.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const params = new URLSearchParams(searchQuery).toString();
    try {
      const { data } = await axios.request<IListRes<ISnsLog>>(
        Enums.HTTP_METHOD.GET,
        paths.SNS + '?' + params
      );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  }
);

export const getSMSConfigAsync = createAsyncThunk(
  'api/getSMSConfigAsync',
  async (_, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    try {
      const { data } = await axios.request<IConfigSns>(
        Enums.HTTP_METHOD.GET,
        paths.SNS_CONFIG
      );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  }
);

export const updateSMSConfigAsync = createAsyncThunk(
  'api/updateSMSConfigAsync',
  async (body: IConfigSns, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    try {
      const { data } = await axios.request<IConfigSns>(
        Enums.HTTP_METHOD.PUT,
        paths.SNS_CONFIG_UPDATE,
        body
      );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  }
);
